import { Style } from 'index';

const CurationImportStyles: Style = {
    actionsContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '2rem',
        bottom: '0',
        padding: '1rem',
        backgroundColor: 'background.paper',
        marginX: '-4px',
        position: 'sticky',
    },
    actionsButton: {
        width: '250px',
    },
    importContainer: {},
};

export default CurationImportStyles;
